const on = (event, fn) => {
  window.addEventListener(event, fn)
}

const off = (event, fn) => {
  window.removeEventListener(event, fn)
}

const emit = (event, opts = {}) => {
  window.dispatchEvent(new CustomEvent(event, opts))
}

export { on, off, emit }
